define([
  "globals",
  "jquery"],
function(globals, $) {

  var toggleScrollTop = function () {
    if ($(window).scrollTop() > 700) {
      $(".bdc-btn-scroll-top").show();
    } else {
      $(".bdc-btn-scroll-top").hide();
    }
  };

  // Toggles "Scroll To Top" button on mobile
  if (globals.ssm.getState("mobile").active) {
    toggleScrollTop();
    $(document).on("click", ".bdc-btn-scroll-top", function () {
      $("html, body").animate({ scrollTop: 0 }, "fast");
    });
    $(window).scroll(function () {
      toggleScrollTop();
    });
  }

});
